export const SET_SELECTED_TIMEZONE = 'SET_SELECTED_TIMEZONE';
export const SET_SIDEBAR_STATUS = 'SET_SIDEBAR_STATUS';
export const SET_STUDIO_RIGHT_PANEL_STATUS = 'SET_STUDIO_RIGHT_PANEL_STATUS';
